<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
	//Herlers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Types
	import type { InputClickEvent } from 'src/types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';
	export let device;

	const id = real_id(device.id);

	const settings = readDeviceSettings(id);

	let loading = false;

	let localIp = get_local_ip(id);

	let reverse = settings[device.category + 's'][device.channel].swap_inputs;

	const sentRequest = async (e: InputClickEvent) => {
		let res;
		loading = true;
		reverse = e.target.checked;

		if (localIp) {
			res = await localReq(device, `${localIp}/settings/roller/0`, 'post', {
				swap_inputs: reverse ? 1 : 0,
			});
		} else {
			res = await postReq(`/device/relay/roller/settings/swap_inputs`, {
				id: id,
				roller_id: device.channel,
				swap_inputs: reverse ? 1 : 0,
			});
		}

		if (res.isok) {
			settings[device.category + 's'][device.channel].swap_inputs = reverse;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('swap_inputs_scc_toast') || `Inputs was swapped.`,
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
			reverse = !reverse;
		}
		loading = false;
	};
</script>

<Toggle size="m" disabled={loading} checked={reverse} on:click={sentRequest} id="toggle-6n94afq">
	{$format('option_reverse_open_close', {
		default: 'If you enable this option, the buttons Open/Close behaviour will be swapped.',
	})}
</Toggle>
